/*
  Remplace AOS (15 Ko + CSS depuis un CDN tiers) par ~1 Ko sans dependance.
  Usage : <div data-reveal> ou <div data-reveal="up" data-reveal-delay="120">
  Le style vit dans zk-core.css (.zk-reveal / .is-revealed).
*/
(function () {
  var SELECTOR = '[data-reveal]';
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function reveal(el) {
    var delay = parseInt(el.getAttribute('data-reveal-delay') || '0', 10);
    if (reduceMotion || !delay) {
      el.classList.add('is-revealed');
      return;
    }
    window.setTimeout(function () {
      el.classList.add('is-revealed');
    }, delay);
  }

  function prepare(el) {
    // La classe n'est posee qu'une fois le JS actif : sans JS, le contenu reste visible.
    el.classList.add('zk-reveal');
  }

  function init(root) {
    var nodes = (root || document).querySelectorAll(SELECTOR);
    if (!nodes.length) return;

    if (reduceMotion || !('IntersectionObserver' in window)) {
      for (var i = 0; i < nodes.length; i++) nodes[i].classList.add('is-revealed');
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        for (var i = 0; i < entries.length; i++) {
          if (!entries[i].isIntersecting) continue;
          reveal(entries[i].target);
          observer.unobserve(entries[i].target);
        }
      },
      { rootMargin: '0px 0px -12% 0px', threshold: 0.01 }
    );

    for (var j = 0; j < nodes.length; j++) {
      prepare(nodes[j]);
      observer.observe(nodes[j]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }

  // L'editeur de theme reinjecte le HTML des sections sans recharger la page.
  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });

  window.zkReveal = init;
})();
